import React, { useState } from "react";

// core components
import { withRouter } from "react-router";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import config from "config.js";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";
import loadContent from "core-module/hoc/loadContent";

import BalanceDueCard from "./BalanceDueCard";

import Button from "common/components/CustomButtons/Button.jsx";
import EditIcon from "@material-ui/icons/Edit";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import * as api from "core-module/services/api";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import { ApiError } from "../../core-module/services/error";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";
import lightBlue from "@material-ui/core/colors/lightBlue";

const importedStyle = dashboardStyle;
const styles = {
  cardIconTitle: importedStyle.cardIconTitle,
  text: {
    margin: 20,
    textAlign: "center",
    alignSelf: "center",
  },
  buttonStyle: {
    margin: "20px",
  },
  highlight: {
    color: "green",
    fontWeight: "bold",
  },
  inline: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
  },
  paymentMethodSummary: {
    display: "inline-flex",
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "8px",
  },
  expiryActionButton: {
    margin: 0,
  },
};

const AutoPaymentSummary = (props) => {
  const [buttonDisable] = useState(false);
  const [expiryDialogOpen, setExpiryDialogOpen] = useState(false);
  const [expiryMonth, setExpiryMonth] = useState("");
  const [expiryYear, setExpiryYear] = useState("");
  const [expiryPaymethodId, setExpiryPaymethodId] = useState(null);
  const [expiryError, setExpiryError] = useState("");
  const { classes, onExpiryChange } = props;
  const ids = useSelector((state) => state.services.ids);

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={6}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <AccountBalanceIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>EFT / Card</h4>
            </CardHeader>
            <CardBody>
              <GridContainer align="center" justify="center">
                {props.message.length > 0 ? (
                  <GridItem xs={12}>
                    <h4 classes={classes.text}>
                      {props.message}
                      <br />
                    </h4>
                  </GridItem>
                ) : null}
                <GridItem xs={12}>
                  <p className={classes.text}>
                    This page provides information on your monthly
                    pre-authorized payments for your MCSnet account.
                    Pre-authorized payments are either stated as Credit Card
                    (including Visa Debit) or EFT/PAD (electronic fund
                    transfer/pre-authorized debit). If you have any questions
                    about your billing, please contact us 1-866-390-3928 ext:1.
                    <br />
                  </p>
                  {props.getList(
                    (oGet, id) => {
                      let type = "";
                      switch (oGet("type")) {
                        case "EF":
                          type = "EFT bank number";
                          break;
                        case "VA":
                          type = "Visa number";
                          break;
                        case "MC":
                          type = "Mastercard number";
                          break;
                        default:
                          break;
                      }

                      const hasCard = ["VA", "MC"].includes(
                        oGet("type", "value")
                      );
                      const expMonthVal = oGet("expmonth", "value");
                      const expYearVal = oGet("expyear", "value");
                      const expYear = String(expYearVal || "").trim();
                      const formattedExpiryYear = /^\d{2}$/.test(expYear)
                        ? `20${expYear}`
                        : /^\d{4}$/.test(expYear)
                        ? expYear
                        : null;
                      const expiryLabel =
                        expMonthVal && formattedExpiryYear
                          ? `${String(expMonthVal).padStart(
                              2,
                              "0"
                            )}/${formattedExpiryYear}`
                          : null;

                      return (
                        <p key="paymethod" className={classes.text}>
                          Your current auto payment method is:
                          <br />
                          <span className={classes.paymentMethodSummary}>
                            <span className={classes.highlight}>
                              {type} {oGet("description")}
                              {hasCard && expiryLabel
                                ? ` · Expires ${expiryLabel}`
                                : null}
                            </span>
                            {hasCard && expiryLabel ? (
                              <Button
                                className={classes.expiryActionButton}
                                color="primary"
                                size="sm"
                                onClick={() => {
                                  setExpiryMonth(
                                    String(expMonthVal).padStart(2, "0")
                                  );
                                  setExpiryYear(formattedExpiryYear);
                                  setExpiryPaymethodId(id);
                                  setExpiryError("");
                                  setExpiryDialogOpen(true);
                                }}
                              >
                                Edit expiry date
                                <EditIcon
                                  aria-hidden="true"
                                  fontSize="small"
                                  style={{
                                    color: lightBlue[600],
                                    marginLeft: "4px",
                                  }}
                                />
                              </Button>
                            ) : null}
                          </span>
                          <br />
                        </p>
                      );
                    },
                    () => {
                      return (
                        <p className={classes.text}>
                          You do not have an active payment method on this
                          account.
                          <br />
                        </p>
                      );
                    }
                  )}
                </GridItem>

                <GridItem xs={12}>
                  <GridContainer align="center" justify="center">
                    <GridItem xs={12}>
                      <Button
                        className={classes.buttonStyle}
                        color="primary"
                        disabled={buttonDisable}
                        onClick={props.goToEFT}
                      >
                        Add EFT/PAD
                      </Button>
                      <Button
                        className={classes.buttonStyle}
                        color="primary"
                        disabled={buttonDisable}
                        onClick={props.goToCreditCard}
                      >
                        Add Card
                      </Button>
                      <br />
                      {ids.hasPreinstall ? (
                        <Link to={config.MYACCOUNT.APP_PATH}>
                          <Button
                            className={classes.buttonStyle}
                            color="success"
                            disabled={false}
                          >
                            Go back to to Main Screen
                          </Button>
                        </Link>
                      ) : null}
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6}>
          <BalanceDueCard id={ids} />
        </GridItem>
      </GridContainer>

      <Dialog
        open={expiryDialogOpen}
        onClose={() => {
          setExpiryDialogOpen(false);
          if (typeof onExpiryChange === "function") {
            onExpiryChange();
          }
          setExpiryError("");
        }}
      >
        <DialogTitle>Edit Card Expiry Date</DialogTitle>
        <DialogContent>
          <p>
            Only the expiry month and year will be updated. Your saved card
            number and payment method will remain unchanged.
          </p>
          <TextField
            label="Expiry Month (MM)"
            value={expiryMonth}
            onChange={(e) => {
              const value = e.target.value;
              setExpiryMonth(value);
            }}
            margin="dense"
            fullWidth
          />
          <TextField
            label="Expiry Year (YYYY)"
            value={expiryYear}
            onChange={(e) => {
              const value = e.target.value;
              setExpiryYear(value);
            }}
            margin="dense"
            fullWidth
            error={Boolean(expiryError)}
            helperText={expiryError}
          />
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={async () => {
              const monthNum = Number(expiryMonth);
              const yearNum = Number(expiryYear);

              if (
                !Number.isInteger(monthNum) ||
                monthNum < 1 ||
                monthNum > 12
              ) {
                setExpiryError("Please enter a valid month between 01 and 12.");
                return;
              }

              if (!/^\d{4}$/.test(expiryYear)) {
                setExpiryError(
                  "Please enter the full 4-digit expiry year (YYYY)."
                );
                return;
              }

              const now = new Date();
              const expiryDate = new Date(yearNum, monthNum, 0); // last day of month

              if (expiryDate < now) {
                setExpiryError("Expiry date must be in the future.");
                return;
              }

              setExpiryError("");

              try {
                const payload = {
                  expmonth: monthNum,
                  expyear: yearNum,
                };

                const res = await api.post(
                  "user." + ids.user + "/autopayment." + expiryPaymethodId,
                  payload
                );

                if (res?.error) {
                  window.alert(res.message || "Unable to update expiry.");
                  return;
                }
                setExpiryDialogOpen(false);
                window.location.reload();
              } catch (e) {
                if (e instanceof ApiError) {
                  window.alert(e.message);
                } else {
                  window.alert("Unable to update expiry.");
                }
              }
            }}
            disabled={!expiryMonth || !expiryYear}
          >
            Save
          </Button>
          <Button
            onClick={() => {
              setExpiryDialogOpen(false);
              setExpiryError("");
            }}
            color="primary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(
  withRouter(loadContent("user.session/autopayment", AutoPaymentSummary))
);
